const copyToClipboard = async (text) => {
  if (text === void 0) return;
  await navigator.clipboard.writeText(text);
};
export {
  copyToClipboard
};
